var flatten = function (arr) {
    if (!Array.isArray(arr)) {
        return arr;
    }
    var result = [];
    arr.forEach(function (item) {
        var flattened = flatten(item);
        var flattenedArray = Array.isArray(flattened) ? flattened : [flattened];
        result = result.concat(flattenedArray);
    });
    return result;
};

var i18nInterpolation = {
    name: 'i18n',
    functional: true,
    props: {
        tag: {
            type: String,
            default: 'span'
        },
        path: {
            type: String,
            required: true
        },
        locale: {
            type: String
        }
    },
    render: function (h, context) {
        var data = context.data, parent = context.parent, props = context.props, slots = context.slots;
        var path = props.path, tag = props.tag;
        var params = slots();
        var children = flatten([parent.$t(path, params)]);
        return h(tag, data, children);
    }
};

/**
 * @description 将对象所有的值，使用 fn 进行转换。（类似 Array#map，但会递归地用到对象上）
 * @param obj 需要转换的对象
 * @param fn 转换函数
 */
function mapValuesDeep(obj, fn) {
    if (typeof obj === 'string') {
        return fn(obj);
    }
    if (Array.isArray(obj)) {
        return obj.map(function (val) { return mapValuesDeep(val, fn); });
    }
    if (typeof obj === 'object') {
        return Object.keys(obj).reduce(function (acc, key) {
            acc[key] = mapValuesDeep(obj[key], fn);
            return acc;
        }, {});
    }
    return obj;
}

var defaultModifier = function (x) { return x; };
/**
 * 国际化文案模板函数，支持以下几种：
 *
 * template("{ a } { b }")({ a: "c", b: "d" }) // "c d"
 * template("{0} {1}")("c", "d") // "c d"
 */
var template = function (source, modifiers, transformers) { return function () {
    var options = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        options[_i] = arguments[_i];
    }
    var applyTransformers = function (value) {
        return transformers.reduce(function (acc, fn) {
            return fn(acc);
        }, value);
    };
    var option = typeof options[0] === 'object' ? options[0] : options;
    var replacers = source.match(/\{[^}]+\}/g) || [];
    var indexRecord = {};
    var splitIndexes = [0];
    replacers.forEach(function (replacer) {
        var startIndex = replacer in indexRecord ? indexRecord[replacer] + replacer.length : 0;
        var index = source.indexOf(replacer, startIndex);
        indexRecord[replacer] = index;
        splitIndexes.push(index, index + replacer.length);
    });
    /**
     * sourceParts 储存分隔后的模板，
     * 例如 source = `foo {bar} baz {qux}`
     * 则 sourceParts = [`foo `, `{bar}`, ` baz `, `{qux}`]
     */
    var sourceParts = splitIndexes
        .map(function (splitIndex, i, arr) {
        // 不能用 || ， 因为 arr[i + 1] 可能为 0
        var nextSplitIndex = arr[i + 1] === undefined ? source.length : arr[i + 1];
        return source.slice(splitIndex, nextSplitIndex);
    })
        .filter(Boolean);
    var replacedParts = sourceParts.map(function (part) {
        if (!/^{/.test(part)) {
            return part;
        }
        var _a = part
            .slice(1, -1)
            .replace(/^\s+|\s$/g, '')
            .split(/\s*,\s*/), key = _a[0], modifierName = _a[1];
        var modifier = modifiers[modifierName] || defaultModifier;
        return modifier(option[key]);
    });
    /**
     * 替换后的模板如果不包含对象/数组，则当做字符串处理。
     * 如果包含对象/数组，则视为 VNode 原样返回，
     * 在 i18n 组件中，该返回值随后会传给 Vue 的 createElement
     * 进行 slot 的替换
     */
    if (replacedParts.every(function (part) { return typeof part !== 'object'; })) {
        return applyTransformers(replacedParts.join(''));
    }
    return replacedParts;
}; };

var KEY_DELIMITER = '.';
var getI18nConfig = function (self) {
    var result = {};
    do {
        Object.assign(result, self.i18n);
        self = self.$parent;
    } while (self);
    return result;
};
var vueI18nTiny = {
    install: function (VueAPI, i18nOptions) {
        if (i18nOptions === void 0) { i18nOptions = {}; }
        var templateOpts = i18nOptions.template || {};
        var _a = templateOpts.formatters, formatters = _a === void 0 ? {} : _a, _b = templateOpts.transformers, transformers = _b === void 0 ? [] : _b;
        var template$1 = templateOpts.engine || template;
        var getByKeys = function (data, keys) {
            var key = keys[0], remainingKeys = keys.slice(1);
            if (!data[key] || typeof data[key] === 'string') {
                return data[key];
            }
            return getByKeys(data[key], remainingKeys);
        };
        var splitKey = function (key) {
            if (/[\w-]+(\.[\w-]+)/.test(key)) {
                return key.split(KEY_DELIMITER).filter(Boolean);
            }
            return [key];
        };
        Object.defineProperty(VueAPI.prototype, 'i18n', {
            get: function () {
                return this.$options.i18n;
            }
        });
        Object.defineProperty(VueAPI.prototype, '$t', {
            get: function () {
                var _this = this;
                return function (key) {
                    var options = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        options[_i - 1] = arguments[_i];
                    }
                    var i18nConfig = getI18nConfig(_this);
                    var str = getByKeys(i18nConfig, splitKey(key));
                    if (!str) {
                        console.warn("[i18n] `" + key + "` does not exist!");
                        if (i18nOptions.defaultsToEmpty) {
                            return '';
                        }
                    }
                    if (typeof options[0] !== 'string') {
                        options[0] = options[0] || {};
                        Object.assign(options[0], i18nConfig);
                    }
                    return template$1(str || key, formatters, transformers).apply(void 0, options);
                };
            }
        });
        Object.defineProperty(VueAPI.prototype, '$te', {
            get: function () {
                var _this = this;
                return function (key) {
                    var i18nConfig = getI18nConfig(_this);
                    var str = getByKeys(i18nConfig, splitKey(key));
                    return !!str;
                };
            }
        });
        Object.defineProperty(VueAPI.prototype, '$ta', {
            get: function () {
                var _this = this;
                return function (obj) { return mapValuesDeep(obj, _this.$t.bind(_this)); };
            }
        });
        VueAPI.component(i18nInterpolation.name, i18nInterpolation);
    }
};

export default vueI18nTiny;
//# sourceMappingURL=vue-i18n-tiny.es5.js.map
